import './index.scss';
import React, { useEffect, useState } from 'react';
import { IWaterMarkProps } from '@umu/umu-types';
import { IGetCustomizeConfigResponse, getCustomizeConfig } from '../../pdfRenderService';
import { getData } from '@umu/umu-util';
import { WaterMark } from '../../../../../@waterMark/waterMark';
export interface IWaterMarkWrapProps {
    isFullscreen: boolean;
    scale: number;
    defaultText: string;
    waterMarkOptions?: IWaterMarkProps;
}

export function WaterMarkWrap(props: IWaterMarkWrapProps) {
    const { waterMarkOptions, isFullscreen, scale, defaultText } = props;
    const [waterMarkText, setwaterMarkText] = useState<string>(defaultText);

    useEffect(() => {
        getWaterMarkText();
    }, []);

    const getWaterMarkText = async () => {
        const config: {
            data: IGetCustomizeConfigResponse;
            error_code: number;
            error_message: string;
        } = await getCustomizeConfig();

        if (config.error_code === 0) {
            setwaterMarkText(getData(config, 'data', 'watermark', 'text'));
        }
    };

    return (
        <WaterMark
            {...waterMarkOptions}
            isFullscreen={isFullscreen}
            renderState={scale}
            text={waterMarkText}
        ></WaterMark>
    );
}
